module.exports = __webpack_public_path__ + "41050772caac9cd79e4a63e84e6fc147.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-underwater.png
// module id = 2998
// module chunks = 0